import AuthService from "services/auth.service";
import { useAppSelector } from "redux/hooks";
import {
  Dialog,
  DialogContent,
  Container,
  Typography,
  Box,
} from "@mui/material";
import Logo from "assets/logo.png";
import CircleLoader from "components/atoms/CircleLoader";
import ForceChangePasswordForm from "./ForceChangePasswordForm";
import "components/templates/AuthForm/AuthForm.css";

/**
 * Blocks the entire app until the admin sets a strong password (mustChangePassword).
 * Rendered at shell level — no dedicated route; navbar is not mounted while open.
 */
export default function ForceChangePasswordGate() {
  const user = useAppSelector((state) => state.auth.user);
  const loading = useAppSelector((state) => state.auth.loading);
  const open = !!user?.mustChangePassword;

  const handleSubmit = (values: any) => {
    AuthService.changeMyPassword({
      currentPassword: values.current_password,
      newPassword: values.password,
    });
  };

  return (
    <Dialog
      fullScreen
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      PaperProps={{
        sx: {
          bgcolor: "background.default",
        },
      }}
    >
      <DialogContent sx={{ p: 0, height: "100%" }}>
        <div className="login-container" style={{ minHeight: "100vh" }}>
          <Container maxWidth="sm">
            <div className="wrap-login">
              {loading && <CircleLoader />}
              <Box component="span" className="login-form-logo">
                <img
                  alt="logo"
                  src={Logo}
                  loading="lazy"
                  width="120px"
                  height="100%"
                  style={{ borderRadius: "85px" }}
                />
              </Box>
              <Typography
                component="span"
                className="login-form-title"
                sx={{ display: "block" }}
              >
                <b>Update your password</b>
              </Typography>
              <Typography
                component="span"
                className="login-form-slogan"
                sx={{ display: "block", mb: 1 }}
              >
                For security, choose a strong password before continuing.
              </Typography>
              <div className="login-form-inner" style={{ padding: "24px 35px 35px" }}>
                <ForceChangePasswordForm onSubmit={handleSubmit} />
              </div>
            </div>
          </Container>
        </div>
      </DialogContent>
    </Dialog>
  );
}
